import { IPills } from '@quicktools/shared-components/components/core/PillsButtons/types';
import { useFormikContext } from 'formik';
import cls from 'classnames';

import useStyles from './styles';
import { IGenericPills } from './types';

function GenericPills({ name, pills, formProps }: IGenericPills) {
  const { setFieldValue } = useFormikContext();
  const classes = useStyles();

  const onSelect = (value: string) => {
    setFieldValue(name, value);
  };
  return (
    <ul className={classes.root}>
      {pills.map((pill: IPills) => {
        const el = (
          <li
            className={cls(classes.item, {
              active: formProps.values[`${name}`] === pill.value,
            })}
            key={pill.value}
            onClick={() => onSelect(pill.value)}
          >
            <span className={classes.text}>{pill.text}</span>
          </li>
        );

        return el;
      })}
    </ul>
  );
}
export default GenericPills;
